/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Composer, { BaseComposerArgs } from 'cio/components/action-composer/base-glimmer';
import { PushPreview } from 'cio/utils/previews';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import PushService from 'cio/services/push';
import { getPushPreviewMeta } from 'cio/utils/push/preview';

type Platform = {
  key: string;
  provider: string;
};

interface ComposerArgs extends BaseComposerArgs {
  preview: PushPreview;
}

interface ComposerSignature {
  Args: ComposerArgs;
  Element: HTMLDivElement;
}

export default class Push extends Composer<ComposerSignature> {
  @service push!: PushService;

  previewObserverKeys = ['args.editableEntity.template.{recipient,body,subject,editor,bodyJson,imageUrl}'];
  previewURL = 'previews/push';

  constructor(owner: unknown, args: ComposerSignature['Args']) {
    super(owner, args);
    this.watchTemplate();
  }

  getPreviewData() {
    return getPushPreviewMeta(this.template, this.providers, this.args.editableEntity);
  }

  get providers() {
    let iosProvider = this.push.platforms.find((p: Platform) => p.key === 'ios')?.provider;
    let androidProvider = this.push.platforms.find((p: Platform) => p.key === 'android')?.provider;

    return { iosProvider, androidProvider };
  }

  get isDirty() {
    return this.template.get('hasDirtyAttributes');
  }

  @action
  rollback() {
    this.template.rollbackAttributes();
    this.args.onRollback();
  }

  @action
  onTemplateSwitch() {
    this.watchTemplate();
  }
}
